import { ComponentsModule } from '../../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { UserTaskNewListPage } from './user-task-new-list';

@NgModule({
  declarations: [UserTaskNewListPage],
  imports: [SellionsLayoutRendererLibModule, IonicPageModule.forChild(UserTaskNewListPage), ComponentsModule],
})
export class UserTaskNewListModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-new-list/user-task-new-list.module.ts